
import { PuttSituation } from "@/types/golf";

export const shortPutts1m: PuttSituation = {
  id: 5,
  name: "Putts courts - 1 m",
  image: "/lovable-uploads/4e812018-3b5f-43a6-87df-f38b7526b006.png?width=800",
  description: "Sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ à 1m.\nPositionner 10 balles au point A et jouer successivement chaque balle.",
  distances: [
    { point: "A", distance: 1, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 2 },
    { condition: "Balle non rentrée", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 40 },
    { points: 2, index: 37 },
    { points: 4, index: 31 },
    { points: 6, index: 25 },
    { points: 8, index: 19 },
    { points: 10, index: 14 },
    { points: 12, index: 9 },
    { points: 14, index: 5 },
    { points: 16, index: 1 },
    { points: 18, index: -2 },
    { points: 20, index: -5 },
  ],
};
